var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGiftCardIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.4001 14.0957L2.39991 8.82796C2.39986 7.50245 3.47438 6.42788 4.79989 6.42787L19.2001 6.42776C20.5256 6.42775 21.6001 7.50227 21.6001 8.82776V14.0957M2.4001 14.0957H21.6001M2.4001 14.0957L2.3999 19.6277C2.39986 20.9532 3.47439 22.0277 4.7999 22.0277H19.2001C20.5256 22.0277 21.6001 20.9532 21.6001 19.6277V14.0957M12.1746 22.0277V6.42775M10.9643 5.92255C11.144 5.91517 11.3101 5.82068 11.3995 5.66594C11.4888 5.5112 11.4875 5.32003 11.4041 5.16075C11.0855 4.58005 9.96742 2.64918 9.23775 2.22791C8.32868 1.70305 7.16098 2.01273 6.63873 2.91731C6.11651 3.82182 6.43206 4.98794 7.3412 5.51283C8.0828 5.941 10.3021 5.93695 10.9643 5.92255ZM12.6347 5.16059C12.5512 5.31992 12.55 5.51103 12.6393 5.66578C12.7287 5.82052 12.8949 5.91496 13.0745 5.92239C13.7368 5.93677 15.968 5.93395 16.6976 5.51267C17.6067 4.98782 17.9224 3.82173 17.4001 2.91715C16.8779 2.01264 15.7102 1.70285 14.8011 2.22774C14.0595 2.65591 12.9533 4.5799 12.6347 5.16059Z",
    stroke: "#101010",
    strokeWidth: 0.666667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiftCardIcon);
export default __webpack_public_path__ + "static/media/gift-card-icon.ae3f373430272bec277fbd76ea6200e0.svg";
export { ForwardRef as ReactComponent };